import genresRequest from './request';
import { IGenre } from '@shared/types/interfaces/genre';
import { Observable } from 'rxjs';

const genreObservable = new Observable<IGenre[]>((subscriber) => {
  subscriber.next([]);
  genresRequest()
    .then((genres) => {
      subscriber.next(genres);
    })
    .catch(() => {
      subscriber.error();
    })
    .finally(() => {
      subscriber.complete();
    });
});

export default genreObservable;
